export default "__VITE_ASSET__T4Q$7WQf__"